import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import * as S from './AuthHome.styles';

const AuthHome = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const userGroups = auth.user?.profile['cognito:groups'] || [];

  // Portal access: any portal_* group
  // 旧的 Test Dashboard 已停用，功能已全部迁移到 Portal（/portal/test-management 等）
  const canAccessPortal = userGroups.some(g => g.startsWith('portal_'));

  // Get display name with fallback logic
  const displayName = auth.user?.profile?.name || auth.user?.profile?.email || 'User';

  // Refresh user info (silent sign-in to get updated groups)
  const handleRefresh = async () => {
    setIsRefreshing(true);
    try {
      await auth.signinSilent();
    } catch (error) {
      console.error('Failed to refresh:', error);
    } finally {
      setIsRefreshing(false);
    }
  };

  // Logout and redirect to login page
  const handleLogout = async () => {
    await auth.removeUser();
    navigate('/login');
  };

  // Redirect to login if not authenticated
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Top bar with refresh and logout buttons
  const TopBarButtons = () => (
    <S.TopBar>
      <S.RefreshButton onClick={handleRefresh} disabled={isRefreshing}>
        {isRefreshing ? 'Refreshing...' : 'Refresh'}
      </S.RefreshButton>
      <S.LogoutButton onClick={handleLogout}>
        Logout
      </S.LogoutButton>
    </S.TopBar>
  );

  // No portal access
  if (!canAccessPortal) {
    return (
      <S.Container>
        <TopBarButtons />
        <S.WelcomeText>Welcome, {displayName}</S.WelcomeText>
        <S.SubText>
          You do not have access to any system. Please contact the administrator.
        </S.SubText>
      </S.Container>
    );
  }

  return (
    <S.Container>
      <TopBarButtons />
      <S.WelcomeText>Welcome, {displayName}</S.WelcomeText>
      <S.SubText>Continue to the Portal</S.SubText>

      <S.ButtonsContainer>
        <S.PortalButton onClick={() => navigate('/portal')}>
          <S.ButtonIcon>🏫</S.ButtonIcon>
          <S.ButtonTitle>Portal</S.ButtonTitle>
          <S.ButtonDescription>
            Student and campus management
          </S.ButtonDescription>
        </S.PortalButton>
      </S.ButtonsContainer>
    </S.Container>
  );
};

export default AuthHome;
